/**
 * #2 Product enquiry — the contact form when the visitor arrived from a
 * product (card-machine product pages, ?product= links from pricing, gateway,
 * EPOS, online payments, integrations, MCA pages). Adds the two questions
 * sales needs to quote: volume and, for card machines, how many.
 */
import {
  company, currentProvider, email, firstName, lastName, message, phone, replyFooter, turnoverBand,
} from "./common";
import { CATEGORY_NEEDS } from "./contactGeneral";

const productEnquiry = {
  id: "product_enquiry",
  label: "Product enquiry",
  crm: {
    layout: "Standard",
    leadSource: "Website Contact Form",
    tags: (values, ctx) => (ctx.product ? [`Product: ${ctx.product}`] : []),
  },
  fields: [
    [firstName, lastName],
    [email, phone],
    company,
    [
      turnoverBand,
      {
        name: "machines", type: "number", label: "How many card machines?", min: 1, max: 500,
        crm: "Number_of_card_machines", showIf: (values, ctx) => ctx.category === "card-machines",
      },
    ],
    currentProvider,
    message,
  ],
  submitLabel: "Send my enquiry",
  footer: replyFooter,
  consent: { variant: "standard" },
  success: { allowReset: true },
  contextToCrm: (ctx) => ({
    Needs: CATEGORY_NEEDS[ctx.category] ? [CATEGORY_NEEDS[ctx.category]] : [],
    IndustrySector: ctx.industryLabel || "",
  }),
  summary: (values, ctx) => `Product enquiry: ${ctx.product}`,
};

export default productEnquiry;
